import { lazy } from 'react';

export const UpdateDetailPageLazy = lazy(() => import('./update-detail-page'));
